import { __assign, __extends } from "tslib";
import React from "react";
import { Platform, TextInput, View, Button, findNodeHandle } from "react-native";
import PropTypes from "prop-types";
import styles from "./PnmacComposer.styles.js";
import PnmacChatViz from "../ChatViz/ChatViz";
var PnmacComposer = /** @class */function (_super) {
  __extends(PnmacComposer, _super);
  function PnmacComposer(props) {
    var _this = _super.call(this, props) || this;
    _this.contentSize = null;
    _this.onChange = function (e) {
      var contentSize = e.nativeEvent.contentSize;
      if (contentSize == undefined || !_this.contentSize) {
        _this.contentSize = contentSize;
        _this.props.onInputSizeChanged(_this.contentSize);
      } else if (contentSize && contentSize != undefined && _this.contentSize.width !== contentSize.width || _this.contentSize.height !== contentSize.height) {
        _this.contentSize = contentSize;
        _this.props.onInputSizeChanged(_this.contentSize);
      }
    };
    _this.onChangeText = function (text) {
      if (_this.props.maxLength && _this.props.maxLength > 0) {
        if (text && text.length > _this.props.maxLength) return;
      }
      _this.props.onTextChanged(text);
    };
    _this.onKeyPress = function (event) {
      if (_this.props.onKeyPress) {
        _this.props.onKeyPress({
          event: event,
          text: _this.props.text
        });
      }
      if (parseInt(event.keyCode) == 13 && _this.props.onSend) {
        _this.props.onSend({
          text: _this.props.text.trim()
        }, true);
      }
    };
    return _this;
  }
  PnmacComposer.prototype.componentDidMount = function () {
    var _this = this;
    if (this.props.setEventListener) {
      this.props.setEventListener(function () {
        _this.props.onSend({
          text: _this.props.text.trim()
        }, true);
      });
    }
  };
  PnmacComposer.prototype.render = function () {
    var _this = this;
    var userCanCancel = this.props.chatBusyState !== "isBusy";
    var chatBusyState = this.props.chatBusyState;
    if (!chatBusyState) chatBusyState = "isReady";
    if (chatBusyState == "isReady") {
      return /*#__PURE__*/React.createElement(TextInput, __assign({
        editable: !this.props.isBlocked,
        placeholder: this.props.placeholder,
        placeholderTextColor: this.props.placeholderTextColor,
        multiline: this.props.multiline,
        keyboardType: Platform.OS === 'ios' ? 'ascii-capable' : 'visible-password',
        onChangeText: function (text) {
          return _this.onChangeText(text);
        },
        onChange: function (e) {
          return _this.onChange(e);
        },
        onKeyPress: function (e) {
          var _a;
          if (Platform.OS != "web") {
            _this.onKeyPress(e);
          } else {
            if (e.key == "Enter" && _this.props.isChatControl && ((_a = _this.props.text) === null || _a === void 0 ? void 0 : _a.trim().length) == 0) {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          }
        },
        style: [styles.textInput, this.props.textInputStyle, {
          height: this.props.composerHeight
        }, this.props.noOutLineOnFocus ? {
          outline: "none !important",
          outlineWidth: 0
        } : {}],
        value: this.props.text,
        accessibilityLabel: this.props.text || this.props.placeholder,
        enablesReturnKeyAutomatically: true,
        underlineColorAndroid: "transparent"
      }, this.props.textInputProps, {
        testID: "composer",
        onFocus: function (event) {
          if (_this.props._scrollToInput) {
            _this.props._scrollToInput(findNodeHandle(event.target));
          }
        }
      }));
    } else {
      return /*#__PURE__*/React.createElement(PnmacChatViz, {
        resetChatState: this.props.resetChatState,
        currentState: chatBusyState,
        userCanCancel: userCanCancel,
        testID: "composer"
      });
    }
  };
  return PnmacComposer;
}(React.Component);
PnmacComposer.defaultProps = {
  onChange: function () {},
  composerHeight: Platform.select({
    ios: 33,
    android: 41,
    web: 50
  }),
  text: "",
  placeholder: "Write a reply...",
  placeholderTextColor: "#b2b2b2",
  textInputProps: null,
  multiline: true,
  textInputStyle: {},
  onTextChanged: function () {},
  onInputSizeChanged: function () {},
  onKeyPress: function () {}
};
PnmacComposer.propTypes = {
  onChange: PropTypes.func,
  composerHeight: PropTypes.number,
  text: PropTypes.string,
  placeholder: PropTypes.string,
  placeholderTextColor: PropTypes.string,
  textInputProps: PropTypes.object,
  onTextChanged: PropTypes.func,
  onInputSizeChanged: PropTypes.func,
  onKeyPress: PropTypes.func,
  multiline: PropTypes.bool,
  textInputStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
};
export default PnmacComposer;